import { type LayoutY } from '#packages/layout';
import type { SlotData } from '../types';

const COMP_OFFSET = 19; // offset from comp's top and bottom Y to match by larger area, smaller than COMP_MARGIN to not trigger already opened slots
const COMP_INNER_OFFSET = 20; // distance from comp's topY that limits matching area for aboveComponent

export function findAvailableSlotV2(
  slots: SlotData[],
  compLayout: LayoutY,
  dragDirection: 'up' | 'down',
) {
  const isWithin = (a: LayoutY, b: LayoutY) =>
    a.y >= b.y && a.y + a.height <= b.y + b.height;

  const matchingBox = {
    y: compLayout.y - COMP_OFFSET,
    height: compLayout.height + COMP_OFFSET * 2,
  };

  return slots.find((currentSlot) => {
    const compBottomY = compLayout.y + compLayout.height;
    const matchingTopYLimit = Math.min(
      compLayout.y + COMP_INNER_OFFSET,
      compBottomY,
    );

    const matchingBottomYLimit = Math.max(
      compBottomY - COMP_INNER_OFFSET,
      compLayout.y,
    );

    const matchesTopPart = matchingTopYLimit > currentSlot.layout.y;
    const matchesBottomPart =
      matchingBottomYLimit < currentSlot.layout.y + currentSlot.layout.height;

    const matchesByDirection =
      (dragDirection === 'down' && matchesBottomPart) ||
      (dragDirection === 'up' && matchesTopPart);

    const isCurrentSlotAvailable =
      isWithin(currentSlot.layout, matchingBox) && matchesByDirection;

    if (isCurrentSlotAvailable) {
      return currentSlot;
    }

    return null;
  });
}
